(function () {
  function runAfterPageLoaded(callback) {
    if (document.body.classList.contains('page-loaded')) {
      callback();
      return;
    }

    window.addEventListener(
      'load',
      function () {
        window.requestAnimationFrame(function () {
          if (document.body.classList.contains('page-loaded')) {
            callback();
          } else {
            setTimeout(callback, 100);
          }
        });
      },
      { once: true }
    );
  }

  function initCursorPictureHero(scope) {
    var heroes = (scope || document).querySelectorAll('[data-cursor-picture-hero]');

    heroes.forEach(function (hero) {
      if (hero.dataset.cursorHeroInit === 'true') return;
      hero.dataset.cursorHeroInit = 'true';

      if (!window.gsap) {
        console.warn('GSAP is not loaded for cursor picture hero animation.');
        return;
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

      if (reduceMotion || coarsePointer) return;

      var pictures = hero.querySelectorAll('.cursor-picture');
      if (!pictures.length) return;

      var currentIndex = 0;
      var lastX = 0;
      var lastY = 0;
      var started = false;
      var zIndexCounter = 80;
      var distanceThreshold = 65;

      gsap.set(pictures, {
        xPercent: -50,
        yPercent: -50,
        opacity: 0,
        visibility: 'hidden',
        scale: 0.8,
        zIndex: 70
      });

      function getDistance(x1, y1, x2, y2) {
        var dx = x2 - x1;
        var dy = y2 - y1;

        return Math.sqrt(dx * dx + dy * dy);
      }

      function showPicture(x, y) {
        var picture = pictures[currentIndex];

        currentIndex = (currentIndex + 1) % pictures.length;

        var rotation = gsap.utils.random(-10, 10);

        gsap.killTweensOf(picture);

        gsap.set(picture, {
          xPercent: -50,
          yPercent: -50,
          x: x,
          y: y,
          zIndex: zIndexCounter++,
          opacity: 1,
          visibility: 'visible',
          scale: 0.55,
          rotation: rotation
        });

        gsap
          .timeline()
          .to(picture, {
            opacity: 1,
            visibility: 'visible',
            scale: 0.7,
            duration: 0.35,
            ease: 'power3.out'
          })
          .to(
            picture,
            {
              opacity: 0,
              visibility: 'hidden',
              scale: 0.7,
              duration: 0.75,
              ease: 'power2.out'
            },
            '+=0.45'
          );
      }

      hero.addEventListener('mousemove', function (event) {
        var rect = hero.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;

        if (!started) {
          started = true;
          lastX = x;
          lastY = y;
          showPicture(x, y);
          return;
        }

        if (getDistance(lastX, lastY, x, y) >= distanceThreshold) {
          showPicture(x, y);
          lastX = x;
          lastY = y;
        }
      });

      hero.addEventListener('mouseleave', function () {
        gsap.to(pictures, {
          opacity: 0,
          visibility: 'hidden',
          duration: 0.2,
          overwrite: true
        });
      });
    });
  }

  runAfterPageLoaded(function () {
    initCursorPictureHero(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    runAfterPageLoaded(function () {
      initCursorPictureHero(event.target);
    });
  });
})();